import { PaginationRequest } from './api';

export enum DocumentType {
	Illustration = 'illustration',
	Onlyfans = 'onlyfans',
	Hitomi = 'hitomi'
}

export interface Documentor {
	metadataID: string;
	metadataName: string;
	count: number;
	files: File[];
}

export interface File {
	id: string;
	sequence: string;
	name: string;
	mimeType: string;
	duration?: string; // mimeType 'video/*' only
	originalURL: string;
	thumbnailURL: string;
	isFavorite: boolean;
}

export interface Document {
	documentUUID: string;
	documentType: DocumentType;
	metadata: Metadata;
	subID: string;
	source: string;
	files: File[];
	isFavorite: boolean;
}

export interface Metadata {
	metadataID: string;
	metadataName: string;
}

export interface DocumentorPaginationRequest extends PaginationRequest {
	metadataName?: string;
	documentType: DocumentType;
}

export interface DocumentPaginationRequest extends PaginationRequest {
	metadataID?: string;
	isFavorite?: boolean;
	mediaType?: string;
	documentType: DocumentType;
}
